import beaver from './main';

export { default as connect } from './connect';
export default beaver;
